module.exports = __webpack_public_path__ + "static/media/wire2.34599850.jpeg";